import { button } from "../../../../../../../../../theme/images";
import {StubbornToolboxProperties} from "../../../../../../../../business/StubbornToolboxMapping";

export const toolbox: StubbornToolboxProperties = {
  name: 'button',
  label: 'Button',
  category: 'Inputs',
  image: button
};
